import { Typography } from "@mui/material"

import { PhoneItemProps } from "./props"
import { ItemContainer, ItemDescriptionContainer } from "../styled"

const PhoneItem = ({ phone, ...rest }: PhoneItemProps) => (
  <ItemContainer {...rest}>
    <ItemDescriptionContainer>
      <Typography variant="h4">{phone}</Typography>
    </ItemDescriptionContainer>
  </ItemContainer>
)

export default PhoneItem
